module.exports = __webpack_public_path__ + "static/media/Group 63.b891c092.svg";